<div class="swipe-hint show-on-mobile">
  <tp-icon name="icons/swipe-left-or-right" class="m-r-2"></tp-icon>
  {{
    isReports
      ? 'Swipe left or right to view full charts.'
      : 'Swipe left or right between the first and last columns to view the full table.'
  }}
</div>
